import { render, staticRenderFns } from "./ChatPlayerList.vue?vue&type=template&id=b17a2346&scoped=true"
import script from "./ChatPlayerList.vue?vue&type=script&lang=js"
export * from "./ChatPlayerList.vue?vue&type=script&lang=js"
import style0 from "./ChatPlayerList.vue?vue&type=style&index=0&id=b17a2346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17a2346",
  null
  
)

export default component.exports